const GET_MATCHES_PLAYLIST_LOADING = 'matches/GET_MATCHES_PLAYLIST_LOADING'
const GET_MATCHES_PLAYLIST_SUCCESS = 'matches/GET_MATCHES_PLAYLIST_SUCCESS'
const GET_MATCHES_PLAYLIST_ERROR = 'matches/GET_MATCHES_PLAYLIST_ERROR'

const GET_MATCHES_GENRESPO_LOADING = 'matches/GET_MATCHES_GENRESPO_LOADING'
const GET_MATCHES_GENRESPO_SUCCESS = 'matches/GET_MATCHES_GENRESPO_SUCCESS'
const GET_MATCHES_GENRESPO_ERROR = 'matches/GET_MATCHES_GENRESPO_ERROR'

const GET_MATCHES_BANNER_LOADING = 'matches/GET_MATCHES_BANNER_LOADING'
const GET_MATCHES_BANNER_SUCCESS = 'matches/GET_MATCHES_BANNER_SUCCESS'
const GET_MATCHES_BANNER_ERROR = 'matches/GET_MATCHES_BANNER_ERROR'

const GET_MATCHES_VIDEO = 'matches/GET_MATCHES_VIDEO'
const UPDATE_ACTIVE_MATCHES_PLAYLIST = 'matches/UPDATE_ACTIVE_MATCHES_PLAYLIST'

const GET_MATCHES_LEAGUE_REQUEST = 'matches/GET_MATCHES_LEAGUE_REQUEST'
const GET_MATCHES_LEAGUE_SUCCESS = 'matches/GET_MATCHES_LEAGUE_SUCCESS'
const GET_MATCHES_LEAGUE_ERROR = 'matches/GET_MATCHES_LEAGUE_ERROR'

const GET_MATCHES_MATCHES_RESET = 'matches/GET_MATCHES_MATCHES_RESET'
const GET_MATCHES_MATCHES_REQUEST = 'matches/GET_MATCHES_MATCHES_REQUEST'
const GET_MATCHES_MATCHES_SUCCESS = 'matches/GET_MATCHES_MATCHES_SUCCESS'
const GET_MATCHES_MATCHES_ERROR = 'matches/GET_MATCHES_MATCHES_ERROR'

const MATCHES_VIDEO_REMINDERS = 'matches/MATCHES_VIDEO_REMINDERS'

const MATCHES_PLAYLISTS_VIDEO_REMINDERS = 'matches/MATCHES_PLAYLISTS_VIDEO_REMINDERS'

export {
  GET_MATCHES_PLAYLIST_LOADING,
  GET_MATCHES_PLAYLIST_SUCCESS,
  GET_MATCHES_PLAYLIST_ERROR,
  GET_MATCHES_VIDEO,
  UPDATE_ACTIVE_MATCHES_PLAYLIST,
  GET_MATCHES_GENRESPO_LOADING,
  GET_MATCHES_GENRESPO_SUCCESS,
  GET_MATCHES_GENRESPO_ERROR,
  GET_MATCHES_BANNER_LOADING,
  GET_MATCHES_BANNER_SUCCESS,
  GET_MATCHES_BANNER_ERROR,
  GET_MATCHES_LEAGUE_REQUEST,
  GET_MATCHES_LEAGUE_SUCCESS,
  GET_MATCHES_LEAGUE_ERROR,
  GET_MATCHES_MATCHES_RESET,
  GET_MATCHES_MATCHES_REQUEST,
  GET_MATCHES_MATCHES_SUCCESS,
  GET_MATCHES_MATCHES_ERROR,
  MATCHES_VIDEO_REMINDERS,
  MATCHES_PLAYLISTS_VIDEO_REMINDERS,
}
